import { PropTypes } from '@amzn/stencil-react-desc'; // This must be a function so that a new PropType object is created each time,
// otherwise all props using this type will copy the same description

export var cssValue = function cssValue() {
  return PropTypes.oneOfType([PropTypes.string, PropTypes.number]);
};
var cssValueEdgeObject = PropTypes.shape({
  left: cssValue(),
  right: cssValue(),
  top: cssValue(),
  bottom: cssValue()
});
var cssValueArray = PropTypes.arrayOf(cssValue());
export var cssMargin = function cssMargin() {
  return PropTypes.oneOfType([cssValue(), cssValueArray, cssValueEdgeObject]);
};
export var cssPadding = cssMargin;